import {
    Button,
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
    Skeleton,
} from '@longy/web-components'
import { Link, useNavigate } from '@tanstack/react-router'
import { UserRound } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { useAuth } from '../../hooks/useAuth'

export const HeaderAccountMenu = () => {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const { user, isAuthenticated, isResolving, logout } = useAuth()

    /**
     * Held rather than guessed. A signed-in visitor refreshing the page has a token but no answer
     * from `getMe` yet, and rendering the sign-in button in that gap told them they were logged out
     * for as long as the request took. Sized like both real states so the header does not shift.
     */
    if (isResolving) {
        return <Skeleton className="h-8 w-28" />
    }

    if (!isAuthenticated) {
        return (
            <Button asChild size="sm" variant="outline">
                <Link to="/login">{t('frontend.auth.login')}</Link>
            </Button>
        )
    }

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button size="sm" variant="outline">
                    <UserRound className="mr-2 size-4" />
                    {user?.firstName || t('frontend.auth.myAccount')}
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
                {/*
                 * The personal entries live here rather than in the main navigation: the account
                 * menu already holds the signed-out and still-resolving cases, so there is no gap
                 * in which a bookings link can flash at someone who is not signed in.
                 */}
                <DropdownMenuItem asChild>
                    <Link to="/bookings">{t('frontend.auth.myBookings')}</Link>
                </DropdownMenuItem>
                <DropdownMenuItem
                    onSelect={() => {
                        logout()
                        navigate({ to: '/' })
                    }}
                >
                    {t('frontend.auth.logout')}
                </DropdownMenuItem>
            </DropdownMenuContent>
        </DropdownMenu>
    )
}
